import { size } from "polished";
import styled from "styled-components";
import ArrowLeftDoubleIcon from "../../img/icons/arrow-double-left.svg?react";
import ArrowRightDoubleIcon from "../../img/icons/arrow-double-right.svg?react";
import ArrowLeftIcon from "../../img/icons/arrow-left.svg?react";
import ArrowRightIcon from "../../img/icons/arrow-right.svg?react";

interface IArrow {
  color?: string;
}

export const ArrowLeft = styled(ArrowLeftIcon)<IArrow>`
  vertical-align: middle;
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;

export const ArrowRight = styled(ArrowRightIcon)<IArrow>`
  vertical-align: middle;
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;

export const ArrowLeftDouble = styled(ArrowLeftDoubleIcon)<IArrow>`
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;

export const ArrowRightDouble = styled(ArrowRightDoubleIcon)<IArrow>`
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;

export const ControlArrowRight = styled(ArrowRight)`
  ${size("16px")};
  margin-inline-start: 0.5rem;
  vertical-align: middle;
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;

export const ControlArrowRightDark = styled(ArrowRight)`
  ${size("16px")};
  margin-inline-start: 0.5rem;
  vertical-align: middle;
  path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

export const ControlArrowLeft = styled(ArrowLeft)`
  ${size("16px")};
  margin-inline-end: 0.5rem;
  vertical-align: middle;
  color: ${(props: any) =>
    props.color ? props.theme.colors[props.color] : "currentColor"};
`;
